// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.src-UserCard-styles-module__card-link--KwfPP{display:flex;text-decoration:none}", "",{"version":3,"sources":["webpack://./src/UserCard/styles.module.scss"],"names":[],"mappings":"AAAA,+CACE,YAAA,CACA,oBAAA","sourcesContent":["a.card-link {\n  display: flex;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card-link": "src-UserCard-styles-module__card-link--KwfPP"
};
export default ___CSS_LOADER_EXPORT___;
